import { render, staticRenderFns } from "./academy.vue?vue&type=template&id=54cb9d56&scoped=true"
import script from "./academy.vue?vue&type=script&lang=js"
export * from "./academy.vue?vue&type=script&lang=js"
import style0 from "./academy.vue?vue&type=style&index=0&id=54cb9d56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb9d56",
  null
  
)

export default component.exports